/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPSyncCustomerMonthData = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The ERPSyncCustomerMonthData model module.
   * @module model/ERPSyncCustomerMonthData
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ERPSyncCustomerMonthData</code>.
   * @alias module:model/ERPSyncCustomerMonthData
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>ERPSyncCustomerMonthData</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ERPSyncCustomerMonthData} obj Optional instance to populate.
   * @return {module:model/ERPSyncCustomerMonthData} The populated <code>ERPSyncCustomerMonthData</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ERPSyncCustomerID')) {
        obj['ERPSyncCustomerID'] = ApiClient.convertToType(data['ERPSyncCustomerID'], 'Integer');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SelectedYear')) {
        obj['SelectedYear'] = ApiClient.convertToType(data['SelectedYear'], 'Integer');
      }
      if (data.hasOwnProperty('SelectedMonth')) {
        obj['SelectedMonth'] = ApiClient.convertToType(data['SelectedMonth'], 'Integer');
      }
      if (data.hasOwnProperty('Date')) {
        obj['Date'] = ApiClient.convertToType(data['Date'], 'Date');
      }
      if (data.hasOwnProperty('Actual')) {
        obj['Actual'] = ApiClient.convertToType(data['Actual'], 'Number');
      }
      if (data.hasOwnProperty('LastUpdate')) {
        obj['LastUpdate'] = ApiClient.convertToType(data['LastUpdate'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ERPSyncCustomerID
   * @default 0
   */
  exports.prototype['ERPSyncCustomerID'] = 0;
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {Integer} SelectedYear
   * @default 0
   */
  exports.prototype['SelectedYear'] = 0;
  /**
   * @member {Integer} SelectedMonth
   * @default 0
   */
  exports.prototype['SelectedMonth'] = 0;
  /**
   * @member {Date} Date
   */
  exports.prototype['Date'] = undefined;
  /**
   * @member {Number} Actual
   * @default 0.0
   */
  exports.prototype['Actual'] = 0.0;
  /**
   * @member {Date} LastUpdate
   */
  exports.prototype['LastUpdate'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


